define('formkit/behavior/single.answer.value.behavior',['require','exports','module','marionette','underscore'],function(require, exports, module) {
  //prettier-ignore
  var Mn = require('marionette'),
      _  = require('underscore');

  /**
    The single answer value behavior should be used on inputs
    that always use a single answer value as their value.  This is
    to protect the single answer from being removed when the backend clears the data.
  */
  var SingleAnswerValueBehavior = Mn.Behavior.extend({
    defaults: {
      resetValue: null,
      templateObjectModel: null,
      form: null,
    },

    onFirstRender: function() {
      var isMultiAnswerValue = this.getOption('isMultiAnswerValue') || this.view.getOption('isMultiAnswerValue');

      if (!isMultiAnswerValue) {
        //prettier-ignore
        var form = this.getOption('form') || this.view.form,
            templateObjectModel = this.getOption('templateObjectModel') || this.view.model,
            answerValueCollection = form.getAnswerValueCollection(templateObjectModel),
            answerValueIndex = this.getOption('answerValueIndex') != null
                             ? this.getOption('answerValueIndex')
                             : this.view.getAnswerValueIndex(),
            answerValueModel = form.getAnswerValueModel(templateObjectModel, answerValueIndex);

        var isRemoved = false;

        // Once the remove event has been fired for an answerValueCollection,
        // this is going to set its answerValueModel's value to the default/reset
        // value. Following the update event, the answerValueModel will be overwritten
        // by any updated value.
        this.listenTo(answerValueCollection, 'remove', function(removedModel, collection, options) {
          if (answerValueModel === removedModel) {
            answerValueModel.set('value', this.getOption('resetValue'), {
              isFromServer: _.result(options, 'isFromServer'),
            });

            isRemoved = true;
          }
        });

        this.listenTo(answerValueCollection, 'update', function(collection, options) {
          if (isRemoved) {
            answerValueCollection.add(answerValueModel, {
              at: answerValueIndex,
              isFromServer: _.result(options, 'isFromServer'),
            });

            isRemoved = false;
          }
        });
      }
    },
  });

  module.exports = SingleAnswerValueBehavior;
});

